import { ListItemIcon } from "@mui/material";
import { styled } from "@mui/system";

import { theme } from "SosTheme";

export const NavListItemIcon = styled(ListItemIcon)({
  minWidth: theme.spacing(3),
  color: "icons",
});
